/**
 * Created by Owner on 2016/8/9.
 */
import {Component, NgModule} from '@angular/core';
import {AlertController, NavParams} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import {CommonService} from "../../services/common.service";

 import {DecimalPipe} from "@angular/common";

@Component({
    templateUrl: 'agencyUserTBalance.html',
    selector: 'agency-user-t-balance-page',
    // pipes: [DecimalPipe],
    providers: [UserService, AppConfigService]
})

// @NgModule({
//   imports: [
//   ],
//   declarations: [
//     DecimalPipe,
//   ],
//   bootstrap: [  ]
// })

export class AgencyUserTBalancePage {
    loginName: string;
    nickName: string;
    id: string;
    tbalance: any = "0";
    isChild: boolean = false;

    constructor(private navParams: NavParams, private alertCtrl: AlertController, private userService: UserService, private cs: CommonService) {
        let data = navParams.get("data");
        if (data) {
            this.isChild = true;
            this.loginName = data.loginname;
            this.nickName = data.nickname;
            this.id = data.id;
        }

        this.initService();
    }

    initService() {
        if (this.isChild) {
            let requestData: any = {
                id: this.id
            };

            this.userService.agentUserTBalance(requestData, this.alertCtrl).then(data => {
                if (!data["msg"]) {
                    this.tbalance = this.cs.numberWithCommas(data["tbalance"]);
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        } else {
            this.userService.agentBalance(undefined, this.alertCtrl).then(data => {
                if (!data["msg"]) {
                    this.tbalance = this.cs.numberWithCommas(data["tbalance"]);
                    this.nickName = data["nickname"];
                    this.loginName = data["loginname"];
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/agencyUserTBalance/agencyUserTBalance.ts